// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2pR-Z","header":"PatientBlock_header__g2tEl","label":"PatientBlock_label__1DhiB","option":"PatientBlock_option__3XNPG"};